/**
 * Servicio para manejar los guardias de navegación
 * Actúa como puente entre el router y los componentes Vue
 */
class NavigationGuardService {
  constructor() {
    this.showManagerLogoutAlertCallback = null;
  }

  /**
   * Registra el callback para mostrar el alert de logout de manager
   * @param {Function} callback - Función que retorna una promesa con la respuesta del usuario
   */
  setShowManagerLogoutAlertCallback(callback) {
    this.showManagerLogoutAlertCallback = callback;
  }

  /**
   * Muestra el alert de logout de manager
   * @returns {Promise<string>} - Retorna "yes" o "no"
   */
  async showManagerLogoutAlert() {
    if (this.showManagerLogoutAlertCallback) {
      return await this.showManagerLogoutAlertCallback();
    }
    // Fallback por si no está registrado el callback
    return window.confirm('Por seguridad, ¿quieres cerrar sesión en Facturación?') ? 'yes' : 'no';
  }
}

// Exportar instancia única (singleton)
export default new NavigationGuardService();
